const renderPageTitle = (path = "") => {
  // if (path.toLowerCase().includes("categories")) return "Categories managment";
  // if (path.toLowerCase().includes("admins")) return "Admins settings";
  // if (path.toLowerCase().includes("pros")) return "PROs managment";
  // if (path.toLowerCase().includes("users")) return "Users managment";
  // if (path.toLowerCase().includes("statistics")) return "Statistics";
};

export default renderPageTitle;
